var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-field',{staticClass:"display-taginput",attrs:{"label":_vm.label,"label-for":_vm.name,"data-testid":_vm.name}},[_c('b-taginput',{attrs:{"value":_vm.value,"id":_vm.name,"closable":false,"disabled":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }